import {
  BANNER_IMPRESSION_UNIQUE,
  BANNER_IMPRESSION_REPEATED,
} from './../constants'
import { GtmAgent } from './GtmAgent'

// Banner 模組的 banner 名稱欄位為 title

// Banner 首次曝光
export const sendBannerImpressionUnique = ({
  banner,
  moduleId,
  bannerLocation,
  venderName,
  venderId,
}) => {
  if (!banner) {
    throw new Error('Banner is empty. Can not send GTM impression data')
  }
  GtmAgent.directSendToGTM({
    event: 'living_action',
    living_event_name: BANNER_IMPRESSION_UNIQUE,
    living_banner_name: banner?.name || banner?.title,
    living_banner_id: banner?._id,
    ...(moduleId && { living_module_id: moduleId }),
    ...(bannerLocation && { living_banner_location: bannerLocation }),
    ...(venderName && { living_vender: venderName }),
    ...(venderId && { living_vender_id: venderId }),
  })
}

// Banner 重複曝光
export const sendBannerImpressionRepeated = ({
  banner,
  moduleId,
  bannerLocation,
  venderName,
  venderId,
}) => {
  if (!banner) {
    throw new Error('Banner is empty. Can not send GTM impression data')
  }
  GtmAgent.directSendToGTM({
    event: 'living_action',
    living_event_name: BANNER_IMPRESSION_REPEATED,
    living_banner_name: banner?.name || banner?.title,
    living_banner_id: banner?._id,
    ...(moduleId && { living_module_id: moduleId }),
    ...(bannerLocation && { living_banner_location: bannerLocation }),
    ...(venderName && { living_vender: venderName }),
    ...(venderId && { living_vender_id: venderId }),
  })
}
